document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.body.classList.add("active");
  }, 1500);

  const halfScreen = window.innerHeight / 1.6;

  window.addEventListener("scroll", () => {
    if (window.scrollY > halfScreen) {
      document.body.classList.add("active-2");
    } else {
      document.body.classList.remove("active-2");
    }
  });
});